import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import BookingUpsellGroupName from "pages/Front/Booking/BookingUpsells/BookingUpsellGroupName";
import GroupedPackageUpsellItem from "pages/Front/Booking/components/PackageUpsell/GroupedPackageUpsellItem";
import PackageUpsellItem from "pages/Front/Booking/components/PackageUpsell/PackageUpsellItem";
import {GroupNameItem} from "utils/upsellsUtils";
import clsx from "clsx";
import {toMapKey, translate} from "utils/utility";
import BookingUpsellCompetitionsGroupName from "pages/Front/Booking/BookingUpsells/BookingUpsellCompetitionsGroupName";

const UpsellGroupNameList = (props: {groupNameItems: GroupNameItem[]}) => {
    const {t} = useTranslation();

    const hasCompetitions = (groupNameItems: GroupNameItem[]): boolean => {
        return groupNameItems.some((g) => g.groupName === "Competitions");
    };

    const sortGroupItemsToPlace = (groupNameItems: GroupNameItem[]): GroupNameItem[] => {
        const compsIndex = groupNameItems.findIndex((g) => g.groupName === "Competitions");
        if (compsIndex === -1) return groupNameItems;

        const result = groupNameItems.slice();
        const [competitions] = result.splice(compsIndex, 1);

        const targetIndex = 1; // place
        const insertIndex = Math.min(targetIndex, result.length);
        result.splice(insertIndex, 0, competitions);

        return result;
    };

    if (props.groupNameItems.length == 0) {
        return <span>{t("No upsells available")}</span>;
    }

    const groupItems = hasCompetitions(props.groupNameItems)
        ? sortGroupItemsToPlace(props.groupNameItems)
        : props.groupNameItems;

    return (
        <>
            {groupItems.map((groupNameItem, i) => {
                const groupNameVisible = groupNameItem.groupName !== "favorites";
                const groupNameCompetitions = groupNameItem.groupName === "Competitions";
                const mapKey = toMapKey(groupNameItem.groupName);
                const [isOpen, setIsOpen] = useState(false);
                return (
                    <div className={"UpsellGroupNameList"} key={mapKey}>
                        {(groupNameVisible && !groupNameCompetitions) && <BookingUpsellGroupName groupNameItem={groupNameItem} isOpen={isOpen} setIsOpen={setIsOpen} />}
                        {(groupNameVisible && groupNameCompetitions) && <BookingUpsellCompetitionsGroupName groupNameItem={groupNameItem} isOpen={isOpen} setIsOpen={setIsOpen} />}
                        <div
                            className={clsx(
                                "UpsellGroupNameListContent",
                                groupNameVisible ? (isOpen ? "max-h-auto pt-4" : "max-h-0 pt-0") : "favorites_ungrouped mb-6 sm:mb-12",
                                "flex flex-col space-y-4 items-center justify-center w-full",
                                groupNameVisible && " overflow-hidden"
                            )}
                        >
                            {groupNameItem.items.map((item, index) => {
                                const mapKeyItem = toMapKey(translate(item.name) + "-" + item.position);
                                return item.is_variant ? (
                                    <GroupedPackageUpsellItem key={mapKeyItem} item={item} />
                                ) : (
                                    <PackageUpsellItem key={mapKeyItem} isNewLayout={true} packageItem={item.items[0]} selectedPackage={null} />
                                );
                            })}
                        </div>
                    </div>
                );
            })}
        </>
    );
};

export default UpsellGroupNameList;
